import React from "react";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Chip from '@mui/material/Chip';
import { usePocketBase } from "./PocketBaseProvider";
import CircularProgress from "@mui/material/CircularProgress";

function SysCheck() {
    const [ loading, setLoading ] = React.useState(true);
    const [ errno, setErrno ] = React.useState(null);
    const pb = usePocketBase();

    React.useEffect(() => {

    if (pb.authStore.isValid) {
            // Listmonk profile attribute 'szervezet' is used to check whether the user was created through shadowSync
            // Fetch subscribers from ListMonk API
            fetch(process.env.REACT_APP_API_URL + `/api/system-logs`, {
                headers: {
                    'Authorization': `${pb.authStore.token}`
                }
            })
            .then(response => response.json())
            .then(data => {
                console.log("Logs loeaded:", data);
                if (data.length > 0) {
                    setErrno(data.length);
                    setLoading(false);
                } else {
                    setErrno(0);
                    setLoading(false);
                }
            })
            .catch(error => {
                setLoading(false);
                console.error("Error fetching Logs:", error);
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pb.authStore.isValid]);

    if (loading) {
        return <Chip icon={<CircularProgress size="20px" />} label="Tölt.." color="primary" sx={{ marginTop: "10px"}} />;
    }
    
    return (
        <div>
            {
                errno === 0 ? (
                    <Chip icon={<CheckCircleIcon />} label="Üzemszerű működés" color="success" sx={{ marginTop: "10px"}} />
                ) : errno > 0 ? (
                    <Chip icon={<ReportProblemIcon sx={{ paddingLeft: "4px" }} />} label={`Problémák vannak (${errno})`} color="error" sx={{ marginTop: "10px"}} />
                ) : null
            }
        </div>
    );
}

export default SysCheck;